module.exports = __webpack_public_path__ + "static/media/pill-pradaxa.93923715.svg";